/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type RevokeRemoteSessionSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type RevokeRemoteSessionSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type RevokeRemoteSessionSecurity = {
  option1?: RevokeRemoteSessionSecurityOption1 | undefined;
  option2?: RevokeRemoteSessionSecurityOption2 | undefined;
};

export type RevokeRemoteSessionRequest = {
  /**
   * The remote_session id.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type RevokeRemoteSessionSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const RevokeRemoteSessionSecurityOption1$outboundSchema: z.ZodMiniType<
  RevokeRemoteSessionSecurityOption1$Outbound,
  RevokeRemoteSessionSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function revokeRemoteSessionSecurityOption1ToJSON(
  revokeRemoteSessionSecurityOption1: RevokeRemoteSessionSecurityOption1,
): string {
  return JSON.stringify(
    RevokeRemoteSessionSecurityOption1$outboundSchema.parse(
      revokeRemoteSessionSecurityOption1,
    ),
  );
}

/** @internal */
export type RevokeRemoteSessionSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const RevokeRemoteSessionSecurityOption2$outboundSchema: z.ZodMiniType<
  RevokeRemoteSessionSecurityOption2$Outbound,
  RevokeRemoteSessionSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function revokeRemoteSessionSecurityOption2ToJSON(
  revokeRemoteSessionSecurityOption2: RevokeRemoteSessionSecurityOption2,
): string {
  return JSON.stringify(
    RevokeRemoteSessionSecurityOption2$outboundSchema.parse(
      revokeRemoteSessionSecurityOption2,
    ),
  );
}

/** @internal */
export type RevokeRemoteSessionSecurity$Outbound = {
  Option1?: RevokeRemoteSessionSecurityOption1$Outbound | undefined;
  Option2?: RevokeRemoteSessionSecurityOption2$Outbound | undefined;
};

/** @internal */
export const RevokeRemoteSessionSecurity$outboundSchema: z.ZodMiniType<
  RevokeRemoteSessionSecurity$Outbound,
  RevokeRemoteSessionSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => RevokeRemoteSessionSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => RevokeRemoteSessionSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function revokeRemoteSessionSecurityToJSON(
  revokeRemoteSessionSecurity: RevokeRemoteSessionSecurity,
): string {
  return JSON.stringify(
    RevokeRemoteSessionSecurity$outboundSchema.parse(
      revokeRemoteSessionSecurity,
    ),
  );
}

/** @internal */
export type RevokeRemoteSessionRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const RevokeRemoteSessionRequest$outboundSchema: z.ZodMiniType<
  RevokeRemoteSessionRequest$Outbound,
  RevokeRemoteSessionRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function revokeRemoteSessionRequestToJSON(
  revokeRemoteSessionRequest: RevokeRemoteSessionRequest,
): string {
  return JSON.stringify(
    RevokeRemoteSessionRequest$outboundSchema.parse(revokeRemoteSessionRequest),
  );
}
